module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Records Report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Profile')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Name')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Age')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('height')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('weight')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Duration')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.username))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.name))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.birthday))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.height))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.weight))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.profile.diabetes_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.profile.diabetes_diagnosis_date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Complications')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Concomitant diseases')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Suggestion')))])]), _vm._v(" "), _vm._l((_vm.complications), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[1]))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[2]))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(item[3]))])])
  }), _vm._v(" "), _vm._m(1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Prescription')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Medicine')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Dose')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Notes')))])]), _vm._v(" "), _vm._l((_vm.prescription), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[1]))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[2]))]), _c('td', {
      staticClass: "td2"
    }, [_vm._v(_vm._s(item[3]))])])
  }), _vm._v(" "), _vm._m(2)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Other suggestions')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v(_vm._s(_vm.$t('HCP')))]), _c('td', {
    staticClass: "td1",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('Content')))])]), _vm._v(" "), _vm._l((_vm.suggestions), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[3]))]), _c('td', {
      staticClass: "td1"
    }, [_vm._v(_vm._s(item[1]))]), _c('td', {
      staticClass: "td2",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item[2]))])])
  }), _vm._v(" "), _vm._m(3)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa7f680e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/record_print.vue
// module id = 1494
// module chunks = 7